import React, { useMemo, useState } from 'react'
import Routers from './Router';
import AnimationThemeProvider from 'common-ui/lib/common/_helper/AnimationTheme/AnimationThemeProvider';
import CustomizerProvider from 'common-ui/lib/common/_helper/Customizer/CustomizerProvider';
import Cookies from 'js-cookie';
import { CURRENT_APP, USER_DETAILS, USER_ROLES, USER_SUBSCRIPTION } from 'common-ui/lib/common/Constant';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const AqiApp = () => {
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = useState({});
  const [accessToken, setAccessToken] = useState(Cookies.get('jwtToken'))
  sessionStorage.setItem('accessToken', Cookies.get('jwtToken') || '');

  const loadReduxData = () => {
    dispatch({
      type: CURRENT_APP,
      payload: 5
    });
    dispatch({
      type: USER_SUBSCRIPTION,
      payload: Cookies.get('userSubscription') ? JSON.parse(Cookies.get('userSubscription')) : []
    });
    dispatch({
      type: USER_ROLES,
      payload: Cookies.get('userRoles') ? JSON.parse(Cookies.get('userRoles')) : {}
    });
    dispatch({
      type: USER_DETAILS,
      payload: Cookies.get('userProfile') ? JSON.parse(Cookies.get('userProfile')) : {}
    })
  };

  const loadApplication = useMemo(() => {
    console.log('triggered')
    loadReduxData();
  }, [])


  return (
    <AnimationThemeProvider>
      <CustomizerProvider>
        {loadApplication}
        <Routers />
        <ToastContainer />
      </CustomizerProvider>
    </AnimationThemeProvider>
  );
};


export default AqiApp;